import { XAxis, YAxis } from 'recharts';
import { CHART_COLORS } from '../vacationOverviewPage.definitions';

interface CompactBarAxesConfig {
	layout: 'vertical' | 'horizontal';
	margin: { top: number; right: number; bottom: number; left: number };
	barRadius: [number, number, number, number];
	yAxisWidth?: number;
}

export function getCompactBarAxesConfig(isCompact: boolean): CompactBarAxesConfig {
	if (!isCompact) {
		return {
			layout: 'horizontal',
			margin: { top: 16, right: 16, left: -16, bottom: 0 },
			barRadius: [4, 4, 0, 0],
		};
	}

	return {
		layout: 'vertical',
		margin: { top: 0, right: 16, bottom: 0, left: 84 },
		barRadius: [0, 4, 4, 0],
		yAxisWidth: 84,
	};
}

interface CompactBarAxesProps {
	isCompact: boolean;
	categoryKey: string;
}

export function CompactBarAxes({ isCompact, categoryKey }: CompactBarAxesProps) {
	if (!isCompact) {
		return (
			<>
				<XAxis dataKey={categoryKey} tick={{ fontSize: 11, fill: CHART_COLORS.axis }} axisLine={false} tickLine={false} />
				<YAxis allowDecimals={false} tick={{ fontSize: 11, fill: CHART_COLORS.axis }} axisLine={false} tickLine={false} />
			</>
		);
	}

	return (
		<>
			<XAxis type="number" allowDecimals={false} tick={{ fontSize: 11, fill: CHART_COLORS.axis }} axisLine={false} tickLine={false} />
			<YAxis type="category" dataKey={categoryKey} width={84} tick={{ fontSize: 11, fill: CHART_COLORS.axis }} axisLine={false} tickLine={false} />
		</>
	);
}
